const { getRequest, BaseURL, postRequest } = require("./axios.handler");

async function fetchExportChatHistory(selectedUserId) {
  try {
    const response = await getRequest({
      endpoint: `/getExportChatbotHistory`,
      params: { clientId: selectedUserId },
      options: { baseURL: BaseURL.AIChatService },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching chat history:", error);
  }
}

async function promptExportChatbot(prompt, selectedUserId) {
  try {
    const response = await postRequest({
      endpoint: `/promptExportChatbot`,
      data: { prompt, clientId: selectedUserId },
      options: { baseURL: BaseURL.AIChatService },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching chat history:", error);
  }
}

module.exports = {
  fetchExportChatHistory,
  promptExportChatbot,
};
